export enum ComponentCtaButtonType {
  Link = 'Link',
  Go = 'Go',
  Mail = 'Mail',
  Coda = 'Coda',
  Grammarly = 'Grammarly',
  Signup = 'Signup',
  Signin = 'Signin',
}

export enum ComponentCtaButtonCategory {
  Primary = 'primary',
  Secondary = 'secondary',
  Tertiary = 'tertiary',
}

export enum CtaDescriptionPosition {
  Left = 'Left',
  Center = 'Center',
}

export enum CtaDescriptionWidth {
  Fixed = 'Fixed',
  Auto = 'Auto',
}

export enum CtaButtonStatus {
  Active = 'Active',
  Disabled = 'Disabled',
}
